import type { RentalApplicationSettings } from '~/use-cases/types/RentalApplication';
import type { RentalApplicationCredentials } from '~/use-cases/types/RentalApplicationCredentials';
import { RentalApplicationSteps } from '~/use-cases/types/RentalApplicationSteps';
import { SiteRoute } from '~/use-cases/types/SiteRoute';

export const RENTAL_APPLICATION_STEP_URLS: Record<RentalApplicationSteps, string> = {
  [RentalApplicationSteps.WELCOME]: '/welcome',
  [RentalApplicationSteps.GET_STARTED]: '/get-started',
  [RentalApplicationSteps.APPLICANT_INFORMATION]: '/applicant-information',
  [RentalApplicationSteps.POTENTIAL_UNITS]: '/potential-units',
  [RentalApplicationSteps.RENTAL_HISTORY]: '/rental-history',
  [RentalApplicationSteps.WORK_HISTORY]: '/employment-income',
  [RentalApplicationSteps.QUESTIONS]: '/rental-questions',
  [RentalApplicationSteps.PETS_AND_CARS]: '/pets-and-cars',
  [RentalApplicationSteps.Pets]: '/pets-and-cars',
  [RentalApplicationSteps.Cars]: '/pets-and-cars',
  [RentalApplicationSteps.TERMS_AND_CONDITIONS]: '/terms-and-conditions',
  [RentalApplicationSteps.SUMMARY]: '/summary',
  [RentalApplicationSteps.CO_APPLICANTS]: '/co-applicants',
  [RentalApplicationSteps.PAYMENT]: '/payment',
  [RentalApplicationSteps.TRANS_UNION_SCREENING]: '/transunion-connection',
  [RentalApplicationSteps.TRANS_UNION_QUESTIONS]: '/questionnaire',
  [RentalApplicationSteps.MANUAL_VERIFICATION]: '/manual-verification',
  [RentalApplicationSteps.APPLICATION_SUBMITTED]: '/application-submitted',
};

export const rentalApplicationBasePath = (credentials: RentalApplicationCredentials): string =>
  `${SiteRoute.RentalApplications}/${credentials.id}/${credentials.password}`;

export const isStepDisabled = (step: RentalApplicationSteps, settings?: RentalApplicationSettings): boolean =>
  !!settings?.disableSteps?.includes(step);

export const arePetsAndCarsDisabled = (settings?: RentalApplicationSettings): boolean =>
  isStepDisabled(RentalApplicationSteps.Pets, settings) && isStepDisabled(RentalApplicationSteps.Cars, settings);
